const objectToString = Object.prototype.toString;

export const isDate = (value: unknown): value is Date => objectToString.call(value) === "[object Date]";
